import { ClientDataService, IClientDataDoc } from '../../../services/clientData.service'

export class ConfigurationsService extends ClientDataService {
  private SERVICE_CONFIG_DOC = 'config-services'
  private SERVICES_BILLING_CONFIG_DOC = 'config-services_billing'
  private CAD_CONFIG_DOC = 'service_cad_config'
  private EKG_CONFIG_DOC = 'service_mdt_config'
  private COMMAND_FACILITY_CONFIG_DOC = 'config-cmdfac'
  private DATA_POINTS_CONFIG = 'config-datapoints'
  private COMMAND_FACILITY_CHARTDEFAULTS_DOC = 'pr_defaults'
  private COMMAND_FACILITY_PROCEDURE_DEFAULT_ACTIONS_DOC = 'cmdfac_prprocedure_defaults'
  private AGENCY_NUMBER_DOC = 'agency_number'
  private DATASET_DETERMINATION_CONFIG_DOC = 'config_dataset_determination'
  private TEXAS_EXPORT_CONFIG_DOC = 'config_texas_export'
  private TEXAS_WRISTBAND_REPORT_TYPE_DOC = 'tb_nemsis3_reporttype'

  async getServiceDoc(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SERVICE_CONFIG_DOC)
  }

  async getServicesBillingDoc(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SERVICES_BILLING_CONFIG_DOC)
  }

  async getCadImportConfig(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CAD_CONFIG_DOC)
  }

  async getEkgImportConfig(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EKG_CONFIG_DOC)
  }

  async getCommandFacilityConfig(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.COMMAND_FACILITY_CONFIG_DOC)
  }

  async getDataPointsConfig(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DATA_POINTS_CONFIG)
  }

  async getCommandFacilityChartDefaults(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.COMMAND_FACILITY_CHARTDEFAULTS_DOC)
  }

  async getCommandFacilityProcedureActionDefaults(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.COMMAND_FACILITY_PROCEDURE_DEFAULT_ACTIONS_DOC)
  }

  async getAgencyNumberDoc(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AGENCY_NUMBER_DOC)
  }

  async getDatasetDeterminationConfig(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DATASET_DETERMINATION_CONFIG_DOC)
  }

  async getTexasExportConfig(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TEXAS_EXPORT_CONFIG_DOC)
  }

  async getTexasWristbandReportTypeConfig(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TEXAS_WRISTBAND_REPORT_TYPE_DOC)
  }
}
